var map = {
	"./amex.png": 7106,
	"./chip.png": 5370,
	"./credit-card.png": 6409,
	"./discover.png": 3918,
	"./mastercard.png": 3846,
	"./troy.png": 3732,
	"./visa.png": 7374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3199;